import React, { useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { SendIcon, UploadIcon } from 'lucide-react';
export function ContactForm() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    position: '',
    phone: '',
    location: '',
    positionType: '',
    urgency: '',
    description: '',
    consent: false
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
  };
  return <section id="contacto" ref={ref} className="py-24 px-6 bg-slate-50" data-id="element-10">
      <div className="max-w-4xl mx-auto" data-id="element-11">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-12">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4" data-id="element-13">
            Formulario de Contacto
          </h2>
          <p className="text-lg text-slate-600" data-id="element-14">
            Cuéntenos qué necesita su organización y coordinaremos una reunión.
          </p>
        </motion.div>

        <motion.form initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: 0.2
      }} onSubmit={handleSubmit} className="bg-white rounded-2xl border border-slate-200 p-8 md:p-12" data-id="element-15">
          <div className="space-y-6" data-id="element-16">
            <div data-id="element-17">
              <label className="block text-sm font-semibold text-slate-700 mb-2" data-id="element-18">
                Nombre y empresa *
              </label>
              <input type="text" placeholder="Ej.: Ana Pérez — Metalúrgica Río" className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent" value={formData.name} onChange={e => setFormData({
              ...formData,
              name: e.target.value
            })} required data-id="element-19" />
            </div>

            <div className="grid md:grid-cols-2 gap-6" data-id="element-20">
              <div data-id="element-21">
                <label className="block text-sm font-semibold text-slate-700 mb-2" data-id="element-22">
                  Correo electrónico *
                </label>
                <input type="email" placeholder="ana@empresa.com" className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent" value={formData.email} onChange={e => setFormData({
                ...formData,
                email: e.target.value
              })} required data-id="element-23" />
              </div>

              <div data-id="element-24">
                <label className="block text-sm font-semibold text-slate-700 mb-2" data-id="element-25">
                  Cargo *
                </label>
                <input type="text" placeholder="Ej.: Responsable de RR. HH." className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent" value={formData.position} onChange={e => setFormData({
                ...formData,
                position: e.target.value
              })} required data-id="element-26" />
              </div>
            </div>

            <div className="grid md:grid-cols-2 gap-6" data-id="element-27">
              <div data-id="element-28">
                <label className="block text-sm font-semibold text-slate-700 mb-2" data-id="element-29">
                  Teléfono (opcional)
                </label>
                <input type="tel" placeholder="+54 9 11 1234-5678" className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent" value={formData.phone} onChange={e => setFormData({
                ...formData,
                phone: e.target.value
              })} data-id="element-30" />
              </div>

              <div data-id="element-31">
                <label className="block text-sm font-semibold text-slate-700 mb-2" data-id="element-32">
                  Ciudad / Provincia *
                </label>
                <input type="text" placeholder="Ej.: Río Segundo — Córdoba" className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent" value={formData.location} onChange={e => setFormData({
                ...formData,
                location: e.target.value
              })} required data-id="element-33" />
              </div>
            </div>

            <div className="grid md:grid-cols-2 gap-6" data-id="element-34">
              <div data-id="element-35">
                <label className="block text-sm font-semibold text-slate-700 mb-2" data-id="element-36">
                  Tipo de posición *
                </label>
                <select className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent" value={formData.positionType} onChange={e => setFormData({
                ...formData,
                positionType: e.target.value
              })} required data-id="element-37">
                  <option value="" data-id="element-38">Seleccionar...</option>
                  <option value="operativa" data-id="element-39">Operativa</option>
                  <option value="mando-medio" data-id="element-40">Mando medio</option>
                  <option value="gerencial" data-id="element-41">Gerencial</option>
                </select>
              </div>

              <div data-id="element-42">
                <label className="block text-sm font-semibold text-slate-700 mb-2" data-id="element-43">
                  Urgencia estimada *
                </label>
                <select className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent" value={formData.urgency} onChange={e => setFormData({
                ...formData,
                urgency: e.target.value
              })} required data-id="element-44">
                  <option value="" data-id="element-45">Seleccionar...</option>
                  <option value="inmediata" data-id="element-46">Inmediata</option>
                  <option value="30-dias" data-id="element-47">30 días</option>
                  <option value="flexible" data-id="element-48">Flexible</option>
                </select>
              </div>
            </div>

            <div data-id="element-49">
              <label className="block text-sm font-semibold text-slate-700 mb-2" data-id="element-50">
                Descripción breve de la búsqueda *
              </label>
              <textarea rows={5} placeholder="Principales tareas, competencias, fecha estimada de ingreso..." className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent resize-none" value={formData.description} onChange={e => setFormData({
              ...formData,
              description: e.target.value
            })} required data-id="element-51" />
            </div>

            <div data-id="element-52">
              <label className="flex items-center justify-center px-6 py-4 border-2 border-dashed border-slate-300 rounded-lg cursor-pointer hover:border-emerald-500 transition-colors" data-id="element-53">
                <UploadIcon className="w-5 h-5 text-slate-400 mr-2" data-id="element-54" />
                <span className="text-sm text-slate-600" data-id="element-55">
                  Adjuntar Perfil/PDF (opcional)
                </span>
                <input type="file" className="hidden" accept=".pdf,.doc,.docx" data-id="element-56" />
              </label>
            </div>

            <div className="flex items-start" data-id="element-57">
              <input type="checkbox" id="consent" className="mt-1 w-4 h-4 text-emerald-600 border-slate-300 rounded focus:ring-emerald-500" checked={formData.consent} onChange={e => setFormData({
              ...formData,
              consent: e.target.checked
            })} required data-id="element-58" />
              <label htmlFor="consent" className="ml-3 text-sm text-slate-600" data-id="element-59">
                Acepto la Política de Privacidad y el tratamiento confidencial
                de mis datos.
              </label>
            </div>

            <p className="text-sm text-slate-500 text-center" data-id="element-60">
              Respuesta dentro de 24–48 h hábiles. Si prefiere coordinar por
              teléfono o videollamada, indíquelo en el mensaje.
            </p>

            <button type="submit" className="w-full group flex items-center justify-center px-8 py-4 bg-emerald-500 text-white font-semibold rounded-lg hover:bg-emerald-600 transition-all duration-300 hover:scale-105" data-id="element-61">
              Enviar consulta
              <SendIcon className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-62" />
            </button>
          </div>
        </motion.form>
      </div>
    </section>;
}